"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerCorpo = void 0;
var react_1 = __importStar(require("react"));
var Corpo_1 = require("../../Tipografia/Corpo/Corpo");
var Cores_1 = require("../../Cores/Cores");
var estiloDatePickerCorpo = require("./DatePickerCorpo.module.scss");
//region gerarDias
var gerarDiasDoMes = function (ano, mes) {
    var dataInicial = new Date(ano, mes - 1, 1);
    var dataFinal = new Date(ano, mes, 0);
    var primeiroDiaSemana = dataInicial.getDay();
    var diasNoMes = [];
    if (primeiroDiaSemana > 0) {
        var ultimoDiaMesAnterior = new Date(ano, mes - 1, 0).getDate();
        for (var i = primeiroDiaSemana - 1; i >= 0; i--) {
            diasNoMes.push({
                dia: ultimoDiaMesAnterior - i,
                pertenceAoMesSelecionado: false,
            });
        }
    }
    for (var dia = 1; dia <= dataFinal.getDate(); dia++) {
        diasNoMes.push({
            dia: dia,
            pertenceAoMesSelecionado: true,
        });
    }
    var diasAdicionais = (7 - (diasNoMes.length % 7)) % 7;
    for (var i = 1; i <= diasAdicionais; i++) {
        diasNoMes.push({
            dia: i,
            pertenceAoMesSelecionado: false,
        });
    }
    return diasNoMes;
};
var calcularAnos = function (anoBase) {
    return Array.from({ length: 16 }, function (_, i) { return anoBase + i - 6; });
};
var DatePickerCorpo = function (_a) {
    var _b = _a.corpoDatePicker, corpoDatePicker = _b === void 0 ? "dia" : _b, _c = _a.dia, dia = _c === void 0 ? "1" : _c, _d = _a.mes, mes = _d === void 0 ? "1" : _d, _e = _a.ano, ano = _e === void 0 ? "2024" : _e, diaClicado = _a.diaClicado, mesClicado = _a.mesClicado, anoClicado = _a.anoClicado, dataSelecionada = _a.dataSelecionada;
    var mesInicial = parseInt(mes);
    var anoInicial = parseInt(ano);
    var _f = (0, react_1.useState)(mesInicial), mesSelecionado = _f[0], setMesSelecionado = _f[1];
    var _g = (0, react_1.useState)(anoInicial), anoSelecionado = _g[0], setAnoSelecionado = _g[1];
    var diasSemana = ["D", "S", "T", "Q", "Q", "S", "S"];
    var diasDoMes = gerarDiasDoMes(anoSelecionado, mesSelecionado);
    var semanas = [];
    for (var i = 0; i < diasDoMes.length; i += 7) {
        semanas.push(diasDoMes.slice(i, i + 7));
    }
    var meses = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
    var tabelaDeMeses = [];
    for (var i = 0; i < 3; i++) {
        var linha = [];
        for (var j = 0; j < 4; j++) {
            var mesIndex = i * 4 + j;
            linha.push(meses[mesIndex]);
        }
        tabelaDeMeses.push(linha);
    }
    var anos = calcularAnos(anoInicial);
    var linhasDeAnos = [];
    for (var i = 0; i < 4; i++) {
        var linha = [];
        for (var j = 0; j < 3; j++) {
            linha.push(anos[i * 3 + j]);
        }
        linhasDeAnos.push(linha);
    }
    //region Semana
    var DiaSemanaRender = (react_1.default.createElement("thead", null,
        react_1.default.createElement("tr", { className: estiloDatePickerCorpo.semana }, diasSemana.map(function (diaSemana, index) { return (react_1.default.createElement("th", { key: index, className: estiloDatePickerCorpo.diaSemana },
            react_1.default.createElement(Corpo_1.Corpo, { style: { cursor: "inherit" }, negrito: 700, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, tipo: "body2", conteudo: diaSemana }))); }))));
    //region Dias
    var DiasRender = (react_1.default.createElement("tbody", null, semanas.map(function (semana, indexSemana) { return (react_1.default.createElement("tr", { key: indexSemana, className: estiloDatePickerCorpo.dias }, semana.map(function (_a, indexDia) {
        var dia = _a.dia, pertenceAoMesSelecionado = _a.pertenceAoMesSelecionado;
        var isSelecionado = dataSelecionada.dia === dia.toString() &&
            dataSelecionada.mes ===
                mesSelecionado.toString() &&
            dataSelecionada.ano ===
                anoSelecionado.toString() &&
            pertenceAoMesSelecionado;
        return (react_1.default.createElement("td", { style: { backgroundColor: isSelecionado ? Cores_1.Cores.GradacaoPrimaria.AzulFillMU400 : "transparent", borderRadius: "50%" }, key: indexDia, className: "".concat(estiloDatePickerCorpo.dia, " ").concat(pertenceAoMesSelecionado
                ? ""
                : estiloDatePickerCorpo.diaOutroMes), onClick: function () {
                return typeof diaClicado === "function" &&
                    diaClicado(dia.toString(), pertenceAoMesSelecionado);
            } },
            react_1.default.createElement("div", { className: isSelecionado
                    ? estiloDatePickerCorpo.selecionado
                    : estiloDatePickerCorpo.naoSelecionado },
                react_1.default.createElement(Corpo_1.Corpo, { style: { cursor: "inherit" }, negrito: 400, cor: isSelecionado
                        ? Cores_1.Cores.CoresIdentidadeMU
                            .brancoMu
                        : pertenceAoMesSelecionado
                            ? Cores_1.Cores.GradacaoNeutros
                                .CinzaFillMU600
                            : Cores_1.Cores.GradacaoNeutros
                                .CinzaFillMU200, corOnHover: isSelecionado
                        ? Cores_1.Cores.CoresIdentidadeMU
                            .brancoMu
                        : Cores_1.Cores.GradacaoPrimaria
                            .AzulMU500, tipo: "body2", conteudo: String(dia) }))));
    }))); })));
    //region Meses
    var MesesRender = (react_1.default.createElement("tbody", { className: estiloDatePickerCorpo.mes }, tabelaDeMeses.map(function (linha, linhaIndex) { return (react_1.default.createElement("tr", { key: linhaIndex, className: estiloDatePickerCorpo.cadaMes }, linha.map(function (mes, index) {
        var mesIndex = linhaIndex * 4 + index;
        var isSelecionado = (mesIndex + 1).toString() ===
            mesSelecionado.toString();
        return (react_1.default.createElement("td", { style: { backgroundColor: isSelecionado ? Cores_1.Cores.GradacaoPrimaria.AzulFillMU400 : "transparent", borderRadius: "16px" }, key: mesIndex, className: "".concat(estiloDatePickerCorpo.mes, " ").concat(isSelecionado ? estiloDatePickerCorpo.selecionado : estiloDatePickerCorpo.naoSelecionado), onClick: function () { return mesClicado((mesIndex + 1).toString()); } },
            react_1.default.createElement(Corpo_1.Corpo, { style: { cursor: "inherit" }, negrito: 400, cor: isSelecionado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, corOnHover: isSelecionado ? Cores_1.Cores.CoresIdentidadeMU.brancoMu : Cores_1.Cores.GradacaoPrimaria.AzulMU500, tipo: "body2", conteudo: mes.toUpperCase() })));
    }))); })));
    //region Anos
    var AnosRender = (react_1.default.createElement("tbody", { className: estiloDatePickerCorpo.tabelaAno }, linhasDeAnos.map(function (linha, linhaIndex) { return (react_1.default.createElement("tr", { key: linhaIndex, className: estiloDatePickerCorpo.linhaAno }, linha.map(function (cadaAno, index) {
        var anoIndex = linhaIndex * 4 + index;
        var isSelecionado = anoSelecionado === cadaAno;
        return (react_1.default.createElement("td", { style: { backgroundColor: isSelecionado ? Cores_1.Cores.GradacaoPrimaria.AzulFillMU400 : "transparent", borderRadius: "16px" }, key: anoIndex, className: estiloDatePickerCorpo.cadaAno, onClick: function () {
                anoClicado(cadaAno.toString());
                setAnoSelecionado(cadaAno);
            } },
            react_1.default.createElement(Corpo_1.Corpo, { style: { cursor: "inherit" }, negrito: 400, cor: isSelecionado
                    ? Cores_1.Cores.CoresIdentidadeMU
                        .brancoMu
                    : Cores_1.Cores.GradacaoNeutros
                        .CinzaFillMU600, corOnHover: isSelecionado
                    ? Cores_1.Cores.CoresIdentidadeMU.brancoMu
                    : Cores_1.Cores.GradacaoPrimaria.AzulMU500, tipo: "body2", conteudo: String(cadaAno) })));
    }))); })));
    //region useEffect
    (0, react_1.useEffect)(function () {
        setMesSelecionado(mesInicial);
        if (corpoDatePicker === "dia") {
            setAnoSelecionado(anoInicial);
        }
    }, [mes, ano, dia]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        corpoDatePicker === "dia" && (react_1.default.createElement("table", { className: estiloDatePickerCorpo.diasDatePicker },
            DiaSemanaRender,
            DiasRender)),
        corpoDatePicker === "mes" && (react_1.default.createElement("table", { className: estiloDatePickerCorpo.mesesDatePicker }, MesesRender)),
        corpoDatePicker === "ano" && (react_1.default.createElement("table", { className: estiloDatePickerCorpo.anosDatePicker }, AnosRender))));
};
exports.DatePickerCorpo = DatePickerCorpo;
